/* Mint-Import: Hàng nhập & container (khổ 1536). Màu chỉ var(--…); số đo theo board (CW 1240, đầu cột 42, dòng 49, chữ 13 / 12). */
.page { display: flex; flex-direction: column; gap: 14px; padding: 2px 0 24px; min-width: 0; }

.seg { display: inline-flex; border-radius: 12px; background: var(--ctl); padding: 4px; }
.tab, .q { display: flex; align-items: center; gap: 7px; height: 34px; padding: 0 14px; border: 0; border-radius: 9px; background: transparent; color: var(--tx2); font: inherit; font-weight: var(--fw-label); white-space: nowrap; cursor: pointer; }
.q { padding: 0 12px; gap: 0; }
.tab[aria-selected='true'], .q[aria-pressed='true'] { background: var(--ctl-on); color: var(--tx); box-shadow: var(--seg-sh); }
.tab:focus-visible, .q:focus-visible, .filter:focus-visible, .act:focus-visible { outline: 2px solid var(--pri); outline-offset: 1px; }
.tabN { min-width: 18px; height: 18px; padding: 0 5px; box-sizing: border-box; border-radius: 9px; background: var(--card); color: var(--lb); font-size: 11px; font-weight: var(--fw-label); line-height: 18px; text-align: center; }
.tab[aria-selected='true'] .tabN { background: var(--pri-bg); color: var(--link); }

.tb { display: flex; align-items: center; gap: 10px; height: 44px; }
.search { display: flex; align-items: center; gap: 10px; width: 300px; height: 42px; box-sizing: border-box; padding: 0 14px; border-radius: 12px; background: var(--card); box-shadow: var(--sh); color: var(--lb); }
.search input { flex: 1; min-width: 0; border: 0; outline: 0; background: transparent; font: inherit; color: var(--tx); }
.search:focus-within { outline: 2px solid var(--pri); outline-offset: 2px; }
.filter { display: inline-flex; align-items: center; gap: 6px; height: 42px; padding: 0 14px; border: 0; border-radius: 12px; background: var(--ctl); color: var(--tx); font: inherit; font-weight: var(--fw-label); cursor: pointer; white-space: nowrap; }
.sums { margin-left: auto; display: flex; gap: 16px; color: var(--tx2); white-space: nowrap; }
.sums b { font-weight: var(--fw-label); }

.note { display: flex; align-items: center; gap: 10px; padding: 10px 14px; border-radius: 12px; background: var(--sub); color: var(--tx2); font-size: 13px; }

.card { border-radius: 16px; background: var(--card); box-shadow: var(--sh); overflow: clip; }
.table { width: 100%; border-collapse: collapse; table-layout: fixed; white-space: nowrap; }
.table th { position: sticky; top: var(--page-head-h, 0px); z-index: 2; box-sizing: border-box; height: 42px; padding: 0 14px; background: var(--card); color: var(--lb); font-size: 12px; font-weight: 500; text-align: left; border-bottom: 1px solid var(--line); }
.table td { height: 49px; padding: 0 14px; overflow: hidden; text-overflow: ellipsis; border-bottom: 1px solid var(--line); font-size: 13px; }
.table tbody tr { cursor: pointer; }
.table .r { text-align: left; }
@media (hover: hover) { .table tbody tr:hover td { background: var(--sub); } }
@media (max-width: 1279px) { .table { min-width: 1000px; } .card { overflow-x: auto; } }

.main { overflow: hidden; text-overflow: ellipsis; }
.sub { font-size: 12px; color: var(--lb); overflow: hidden; text-overflow: ellipsis; }
.fw { font-weight: var(--fw-label); }
.link { color: var(--link); }
.ok { color: var(--ok); } .warn { color: var(--warn); } .err { color: var(--err); } .lb { color: var(--lb); } .tx2 { color: var(--tx2); }

.pill { display: inline-flex; align-items: center; gap: 6px; padding: 3px 10px; border-radius: 999px; font-size: 12px; font-weight: var(--fw-label); color: var(--tx); }
.dot { width: 8px; height: 8px; border-radius: 50%; }
.p_ok { background: var(--ok-bg); } .p_ok .dot { background: var(--ok-dot); }
.p_warn { background: var(--warn-bg); } .p_warn .dot { background: var(--d-amber); }
.p_err { background: var(--err-bg); } .p_err .dot { background: var(--err); }
.p_pri { background: var(--pri-bg); } .p_pri .dot { background: var(--d-blue); }
.p_vio { background: var(--pri-bg); } .p_vio .dot { background: var(--d-violet); }
.p_mute { background: var(--ctl); } .p_mute .dot { background: var(--d-gray); }

.clock { display: flex; align-items: center; gap: 8px; }
.bar { flex: 1; height: 6px; border-radius: 3px; background: var(--line); overflow: hidden; }
.bar i { display: block; height: 100%; border-radius: 3px; background: var(--d-blue); }
.bar.soon i { background: var(--d-amber); }
.bar.over i { background: var(--err); }
.clock b { min-width: 56px; text-align: right; font-weight: var(--fw-label); }

.act { display: inline-flex; align-items: center; justify-content: center; gap: 6px; height: 32px; padding: 0 12px; border: 0; border-radius: 9px; font: inherit; font-size: 13px; font-weight: var(--fw-label); white-space: nowrap; cursor: pointer; }
.a_pri { background: var(--btn); color: var(--btn-tx); }
.a_warn { background: var(--warn-bg); color: var(--warn); }
.a_mute { background: var(--ctl); color: var(--lb); }

.foot { display: flex; align-items: center; justify-content: space-between; height: 44px; padding: 0 18px; box-sizing: border-box; font-size: 13px; color: var(--lb); }

.dense .table td { height: 41px; }

/* 1920: bảng phải 372 cạnh vùng giữa */
.body { display: block; min-width: 0; }
.bodyDock { display: grid; grid-template-columns: minmax(0, 1fr) 372px; gap: 14px; align-items: start; }

/* Mint-Import · trang chi tiết 2:1 (DP21) — mốc hành trình */
.stp { display: flex; align-items: center; gap: 10px; min-height: 36px; border-top: 1px solid var(--line); font-size: 13px; }
.stp:first-child { border-top: 0; }
.stpDot { width: 10px; height: 10px; border-radius: 50%; background: var(--bd); flex-shrink: 0; }
.stpOk { background: var(--ok); }
.stpCur { background: var(--warn); box-shadow: 0 0 0 4px var(--warn-bg); }
.stpK { flex: 1 1 0; min-width: 0; }
.stpV { font-size: 12px; color: var(--lb); }
.stpCurTx { font-weight: var(--fw-title); }
.alr { display: flex; align-items: flex-start; gap: 8px; margin-bottom: 8px; padding: 10px 12px; border-radius: 12px; font-size: 13px; }
.alrWarn { background: var(--warn-bg); color: var(--warn); }
.alrErr { background: var(--err-bg); color: var(--err); }
.alrInfo { background: var(--pri-bg); color: var(--link); }
.stp { min-height: 57px; }
.okTx { color: var(--ok); font-weight: var(--fw-title); }
.warnTx { color: var(--warn); font-weight: var(--fw-title); }
.ell { display: block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
